/**
 * Query to find products
 */
export const PRODUCTS = `
  query FindProductsWithQuery($query: String!, $first: Int) {
    products(query: $query, first: $first) {
      nodes {
        id
        title
        handle
        productType
        images(first: 3) {
          nodes {
            url
          }
        }
        variants(first: 3) {
          nodes {
            id
            price {
              amount
            }
            sku
          }
        }
        metafield(namespace: "custom", key: "four_pack") {
          key
          value
        }
      }
    }
  }
`;

/**
 * Query to fetch data about a product collection
 */
export const PRODUCT_COLLECTIONS = `
  query FindCollectionsWithQuery($first: Int!, $query: String!) {
    collections(first: $first, query: $query) {
      nodes {
        id
        title
        handle
        products(first: 6) {
          nodes {
            id
            title
            handle
            productType
            images(first: 3) {
              nodes {
                url
              }
            }
            variants(first: 1) {
              nodes {
                id
                sku
                price {
                  amount
                  currencyCode
                }
              }
            }
            metafields(
              identifiers: [
                { namespace: "details", key: "bag_volume" }
                { namespace: "custom", key: "four_pack" }
              ]
            ) {
              key
              value
            }
          }
        }
      }
    }
  }
`;
